export const COMPONENT_NAME = 'Datepicker';
